export default {
  TAG_LINK_INCLUDE: 'ads.oiads.com.br/p/TM68SMr5',
};
